/**
 * ユーザー
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/administrators`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      name: null,
      role: null,
    },
  }
}

const user = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * ユーザー一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param role
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, role, page }) {
      dispatch('saveCondition', { name: name, role: role })
      const params = { name: state.condition.name, role: state.condition.role, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.ADMIN_USER, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { name, role }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _role = (role !== undefined) ? role : state.condition.role
      const params = { name: _name, role: _role }
      commit(types.ADMIN_USER_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.ADMIN_USER_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_USER_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_USER_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_USER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_USER] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_USER_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.role = params.role
    }
  },
}

export default user

